module.exports = __webpack_public_path__ + "static/media/outside_director_image.75456e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/outside_director_image.png
// module id = 495
// module chunks = 0